<template>
    <router-view></router-view>
</template>

<script>
    import {USER_REQUEST} from "./store/actions/user";
    import NbInvitation from "./components/Role/NbInvitationCounter.vue";

export default {
    name: 'app',
    components : {
        'mes-invitations' : NbInvitation},
    created() {
        this.$store.dispatch(USER_REQUEST);
    }
};
</script>

<style lang="scss">
    /* Import Themify Icons Icons Set */
    $ti-font-path: "~themify-icons-scss/fonts/";
    @import "~themify-icons-scss/scss/themify-icons.scss";
    /* Import Font Awesome Icons Set */
    $fa-font-path: "~font-awesome/fonts/";
    @import "~font-awesome/scss/font-awesome.scss";
    /* Import Bootstrap Vue Styles */
    @import "~bootstrap/dist/css/bootstrap.css";
    /* Import Bootstrap Vue Styles */
    @import "~bootstrap-vue/dist/bootstrap-vue.css";
    // Import Main styles for this application
    @import "./assets/scss/app.scss";
    @import "../node_modules/ag-grid-community/dist/styles/ag-grid.css";
    @import "../node_modules/ag-grid-community/dist/styles/ag-theme-alpine.css";
</style>
